import React from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  // Placeholders — replace with real client testimonials (with their permission).
  const testimonials = [{
    name: '[Client name 1]',
    initial: '?',
    text: '[Real testimonial here — e.g. the process they resolved with the translation, like "I used it for my green card and USCIS accepted it with no problem."]',
    role: '[Type of process]'
  }, {
    name: '[Client name 2]',
    initial: '?',
    text: '[Real testimonial here — focus it on speed or on being accepted by the official institution.]',
    role: '[Type of process]'
  }, {
    name: '[Client name 3]',
    initial: '?',
    text: '[Real testimonial here — focus it on trust and certification.]',
    role: '[Type of process]'
  }];
  return <section id="testimonios" className="py-20 bg-gray-50 scroll-mt-24" data-id="element-130">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-131">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-132">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-133">
            Success stories
          </h2>
          <p className="text-lg text-gray-600" data-id="element-134">
            Hundreds of immigrants and professionals trust us with their most
            important paperwork.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-135">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-136">
              <div className="flex gap-1 mb-4" data-id="element-137">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-138" />)}
              </div>
              <p className="text-gray-700 mb-6 italic" data-id="element-139">"{testimonial.text}"</p>
              <div className="flex items-center gap-4" data-id="element-140">
                <div className="w-12 h-12 bg-blue-100 text-blue-800 rounded-full flex items-center justify-center font-bold text-lg" data-id="element-141">
                  {testimonial.initial}
                </div>
                <div data-id="element-142">
                  <p className="font-bold text-gray-900" data-id="element-143">{testimonial.name}</p>
                  <p className="text-sm text-gray-500" data-id="element-144">{testimonial.role}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}